import React, { useEffect, useRef, useState } from 'react';
import { Monitor, Smartphone, Upload, Trash2, Plus, X, Move } from 'lucide-react';
import FormVista from '../../components/form/FormVista';
import {
  TEMI, COPERTINE, SFONDI, COLORI, ELENCO_COPERTINE, ELENCO_SFONDI, ELENCO_CARATTERI, ELENCO_CAMPI, MODALITA, ALTEZZE, ELENCO_ALTEZZE,
  aspettoCompleto, temaAttuale, riduciFoto,
} from '../../components/form/formAspetto';
import { s } from './FormLista';
import useIsMobile from '../../utils/useIsMobile';

// Scheda "Aspetto" dell'editor: scelte a sinistra, anteprima viva a destra.
export default function FormAspetto({ f, setAspetto, url, caricaFoto, togliFoto, puoModificare }) {
  const a = aspettoCompleto(f.aspetto);
  const tema = temaAttuale(a);
  const [carica, setCarica] = useState('');
  const [errore, setErrore] = useState('');
  const [nuovaEtichetta, setNuovaEtichetta] = useState('');
  const mobile = useIsMobile();

  const scegliFoto = async (tipo, file) => {
    if (!file) return;
    setErrore(''); setCarica(tipo);
    try {
      const { dati } = await riduciFoto(file);
      await caricaFoto(tipo, dati);
    } catch (e) { setErrore(e.response?.data?.error || e.message || 'Caricamento non riuscito'); }
    finally { setCarica(''); }
  };
  const aggiungiEtichetta = () => {
    const t = nuovaEtichetta.trim();
    if (!t || a.etichette.length >= 6) return;
    setAspetto({ etichette: [...a.etichette, t.slice(0, 40)] }); setNuovaEtichetta('');
  };

  return (
    <div style={{ ...st.griglia, ...(mobile ? { gridTemplateColumns: 'minmax(0, 1fr)' } : {}) }}>
      <fieldset disabled={!puoModificare} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
        {errore && <div style={s.errore}>{errore}</div>}

        <div style={s.card}>
          <div style={s.cardTitle}>TEMA PRONTO</div>
          <div style={st.temi}>
            {Object.entries(TEMI).map(([k, t]) => (
              <button key={k} type="button" style={{ ...st.tema, ...(tema === k ? st.temaOn : {}) }} onClick={() => setAspetto({ copertina: t.copertina, sfondo: t.sfondo, colore: t.colore, caratteri: t.caratteri, campi: t.campi })}>
                <i style={{ ...st.temaImg, background: COPERTINE[t.copertina] }} />
                <span style={st.temaNome}>{t.nome}</span>
              </button>
            ))}
          </div>
          <p style={s.help}>Il tema imposta copertina, sfondo, colore e caratteri; poi puoi cambiare ogni cosa qui sotto.</p>
        </div>

        <div style={s.card}>
          <div style={s.cardTitle}>IMPAGINAZIONE</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {MODALITA.map(([k, l, d]) => (
              <label key={k} style={{ ...st.radio, ...(a.modalita === k ? st.radioOn : {}) }}>
                <input type="radio" name="modalita" checked={a.modalita === k} onChange={() => setAspetto({ modalita: k })} style={{ accentColor: '#F4600C', marginTop: 3 }} />
                <span><b>{l}</b><span style={{ display: 'block', ...s.help, marginTop: 2 }}>{d}</span></span>
              </label>
            ))}
          </div>
          {a.modalita === 'sezioni' && !f.campi.some(c => c.tipo === 'SEZIONE') && <p style={{ ...s.help, color: '#B45309' }}>Il form non ha ancora nessun "Titolo e testo": finché non ne aggiungi, si vede come pagina unica.</p>}
        </div>

        <div style={s.card}>
          <div style={s.cardTitle}>COPERTINA</div>
          <div style={st.chips}>
            {ELENCO_COPERTINE.map(([k, l]) => <Chip key={k} on={a.copertina === k} onClick={() => setAspetto({ copertina: k })}>{l}</Chip>)}
            {a.copertina_img && <Chip on={a.copertina === 'foto'} onClick={() => setAspetto({ copertina: 'foto' })}>La tua foto</Chip>}
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12, alignItems: 'center' }}>
            <label style={{ ...s.btnSec, cursor: puoModificare ? 'pointer' : 'not-allowed' }}>
              <Upload size={13} /> {carica === 'copertina' ? 'CARICAMENTO…' : a.copertina_img ? 'CAMBIA FOTO' : 'CARICA UNA FOTO'}
              <input type="file" accept="image/jpeg,image/png,image/webp" style={{ display: 'none' }} disabled={!puoModificare || !!carica} onChange={e => { scegliFoto('copertina', e.target.files[0]); e.target.value = ''; }} />
            </label>
            {a.copertina_img && <button type="button" style={s.btnSec} onClick={() => togliFoto('copertina')}><Trash2 size={13} /> TOGLI FOTO</button>}
          </div>
          <div style={st.consiglio}>
            <b>Che foto usare.</b> Orizzontale, almeno 1600 px di larghezza (ideale circa 2000 × 700, cioè 3 volte più larga che alta). Su computer la copertina è larga e bassa; su telefono è più stretta e la foto si taglia ai lati. Tieni il soggetto vicino al centro. La foto viene ridotta e alleggerita da sola al caricamento.
          </div>
          {a.copertina === 'foto' && url.copertina && (
            <Inquadratura src={url.copertina} pos={a.copertina_pos} altezza={a.copertina_altezza} onPos={p => setAspetto({ copertina_pos: p })} disabled={!puoModificare} />
          )}
          {a.copertina !== 'nessuna' && <>
            <label style={{ ...s.label, marginTop: 14 }}>ALTEZZA</label>
            <div style={st.chips}>
              {ELENCO_ALTEZZE.map(([k, l]) => <Chip key={k} on={a.copertina_altezza === k} onClick={() => setAspetto({ copertina_altezza: k })}>{l} <span style={{ opacity: .6, fontWeight: 500 }}>{ALTEZZE[k][0]} px</span></Chip>)}
            </div>
            <p style={s.help}>Su telefono la copertina è un po' più bassa ({ELENCO_ALTEZZE.map(([k]) => ALTEZZE[k][1]).join(' / ')} px).</p>
            <label style={st.check}><input type="checkbox" checked={a.slogan} onChange={e => setAspetto({ slogan: e.target.checked })} style={{ accentColor: '#F4600C' }} /> Mostra lo slogan sulla copertina</label>
            {a.slogan && <>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10, marginTop: 8 }}>
                <div><label style={s.label}>PRIMA RIGA (BIANCA)</label><input style={s.inp} maxLength={40} value={a.slogan_1 ?? ''} onChange={e => setAspetto({ slogan_1: e.target.value })} placeholder="Ci vediamo" /></div>
                <div><label style={s.label}>SECONDA RIGA (ARANCIO)</label><input style={s.inp} maxLength={40} value={a.slogan_2 ?? ''} onChange={e => setAspetto({ slogan_2: e.target.value })} placeholder="sulla sabbia." /></div>
              </div>
              <p style={s.help}>Lo stesso testo compare anche nella pagina di ringraziamento e nel benvenuto della modalità "una alla volta". Max 40 caratteri per riga. <button type="button" style={{ background: 'none', border: 0, color: '#F4600C', cursor: 'pointer', padding: 0, font: 'inherit' }} onClick={() => setAspetto({ slogan_1: 'Ci vediamo', slogan_2: 'sulla sabbia.' })}>Rimetti quello di base</button></p>
            </>}
          </>}
        </div>

        <div style={s.card}>
          <div style={s.cardTitle}>SFONDO DELLA PAGINA</div>
          <div style={st.chips}>
            {ELENCO_SFONDI.map(([k, l]) => <Chip key={k} on={a.sfondo === k} onClick={() => setAspetto({ sfondo: k })} campione={SFONDI[k].pg}>{l}</Chip>)}
            {a.sfondo_img && <Chip on={a.sfondo === 'foto'} onClick={() => setAspetto({ sfondo: 'foto' })}>La tua foto</Chip>}
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
            <label style={{ ...s.btnSec, cursor: puoModificare ? 'pointer' : 'not-allowed' }}>
              <Upload size={13} /> {carica === 'sfondo' ? 'CARICAMENTO…' : a.sfondo_img ? 'CAMBIA FOTO DI SFONDO' : 'FOTO COME SFONDO'}
              <input type="file" accept="image/jpeg,image/png,image/webp" style={{ display: 'none' }} disabled={!puoModificare || !!carica} onChange={e => { scegliFoto('sfondo', e.target.files[0]); e.target.value = ''; }} />
            </label>
            {a.sfondo_img && <button type="button" style={s.btnSec} onClick={() => togliFoto('sfondo')}><Trash2 size={13} /> TOGLI</button>}
          </div>
          <p style={s.help}>La foto di sfondo copre tutta la pagina e viene scurita un po' per far leggere le schede: meglio un'immagine tranquilla (sabbia, cielo, rete), anche verticale.</p>
        </div>

        <div style={s.card}>
          <div style={s.cardTitle}>COLORE, CARATTERI, CAMPI</div>
          <label style={s.label}>COLORE PRINCIPALE</label>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {COLORI.map(c => (
              <button key={c} type="button" aria-label={`Colore ${c}`} onClick={() => setAspetto({ colore: c })}
                style={{ width: 32, height: 32, borderRadius: '50%', background: c, border: '3px solid #fff', boxShadow: a.colore === c ? '0 0 0 2px var(--text)' : '0 0 0 1px var(--border2)', cursor: 'pointer', padding: 0 }} />
            ))}
          </div>
          <label style={{ ...s.label, marginTop: 14 }}>CARATTERI DEI TITOLI</label>
          <div style={st.chips}>{ELENCO_CARATTERI.map(([k, l]) => <Chip key={k} on={a.caratteri === k} onClick={() => setAspetto({ caratteri: k })}>{l}</Chip>)}</div>
          <label style={{ ...s.label, marginTop: 14 }}>STILE DEI CAMPI</label>
          <div style={st.chips}>{ELENCO_CAMPI.map(([k, l]) => <Chip key={k} on={a.campi === k} onClick={() => setAspetto({ campi: k })}>{l}</Chip>)}</div>
        </div>

        <div style={s.card}>
          <div style={s.cardTitle}>SOTTO IL TITOLO</div>
          <label style={s.label}>ETICHETTE (max 6, es. "Ottobre → maggio", "5 sedi", "2 minuti")</label>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
            {a.etichette.map((e, i) => (
              <span key={i} style={st.etichetta}>{e}<button type="button" style={st.xBtn} onClick={() => setAspetto({ etichette: a.etichette.filter((_, j) => j !== i) })} aria-label={`Togli ${e}`}><X size={12} /></button></span>
            ))}
          </div>
          {a.etichette.length < 6 && (
            <div style={{ display: 'flex', gap: 6 }}>
              <input style={s.inp} value={nuovaEtichetta} maxLength={40} placeholder="Nuova etichetta" onChange={e => setNuovaEtichetta(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); aggiungiEtichetta(); } }} />
              <button type="button" style={s.btnSec} onClick={aggiungiEtichetta}><Plus size={13} /></button>
            </div>
          )}
          <label style={{ ...s.label, marginTop: 14 }}>TESTO DEL BOTTONE DI INVIO</label>
          <input style={{ ...s.inp, maxWidth: 280 }} value={a.testo_invio || ''} maxLength={40} placeholder="Invia" onChange={e => setAspetto({ testo_invio: e.target.value })} />
        </div>
      </fieldset>

      <div style={mobile ? { minWidth: 0 } : st.colonnaAnteprima}>
        <Anteprima f={f} url={url} />
      </div>
    </div>
  );
}

// Anteprima viva del form, come computer (rimpicciolito) o come telefono
export function Anteprima({ f, url, altezza = 'calc(100vh - 170px)' }) {
  const [dispositivo, setDispositivo] = useState(() => { try { return localStorage.getItem('form_anteprima_dispositivo') || 'pc'; } catch { return 'pc'; } });
  const scatola = useRef(null);
  const [zoom, setZoom] = useState(1);
  useEffect(() => { try { localStorage.setItem('form_anteprima_dispositivo', dispositivo); } catch { /* niente */ } }, [dispositivo]);
  useEffect(() => {
    if (!scatola.current) return undefined;
    const ro = new ResizeObserver(([e]) => setZoom(Math.min(1, e.contentRect.width / 1100)));
    ro.observe(scatola.current);
    return () => ro.disconnect();
  }, []);
  const pc = dispositivo === 'pc';
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, gap: 8, flexWrap: 'wrap' }}>
        <span style={s.cardTitle}>ANTEPRIMA · le risposte non vengono inviate</span>
        <div style={st.seg}>
          <button type="button" style={{ ...st.segBtn, ...(pc ? st.segOn : {}) }} onClick={() => setDispositivo('pc')}><Monitor size={13} /> Computer</button>
          <button type="button" style={{ ...st.segBtn, ...(!pc ? st.segOn : {}) }} onClick={() => setDispositivo('tel')}><Smartphone size={13} /> Telefono</button>
        </div>
      </div>
      <div ref={scatola} style={{ width: '100%' }}>
        <div style={pc
          ? { height: altezza, minHeight: 420, overflowY: 'auto', borderRadius: 16, boxShadow: '0 1px 2px rgba(0,0,0,.05), 0 10px 30px rgba(0,0,0,.08)', background: '#F2F2F5' }
          : { width: 390, maxWidth: '100%', height: 760, maxHeight: altezza, minHeight: 420, overflowY: 'auto', margin: '0 auto', borderRadius: 30, border: '8px solid #1D1D1F', boxShadow: '0 10px 30px rgba(0,0,0,.18)', background: '#F2F2F5' }}>
          <div style={pc ? { width: 1100, zoom } : undefined}>
            <FormVista key={JSON.stringify(f.campi)} form={f} url={url} anteprima onInvia={() => {}} />
          </div>
        </div>
      </div>
    </div>
  );
}

// Foto intera con le due zone visibili (computer e telefono): si trascina il punto per scegliere cosa resta in vista
function Inquadratura({ src, pos, altezza, onPos, disabled }) {
  const [dim, setDim] = useState(null);
  const area = useRef(null);
  const trascina = useRef(false);
  const [hPc, hTel] = ALTEZZE[altezza] || ALTEZZE.media;

  const zona = (w, h) => {
    if (!dim) return null;
    const scala = Math.max(w / dim.w, h / dim.h);
    const larg = w / scala, alt = h / scala;
    const left = (dim.w - larg) * pos.x / 100, top = (dim.h - alt) * pos.y / 100;
    return { left: `${(left / dim.w) * 100}%`, top: `${(top / dim.h) * 100}%`, width: `${(larg / dim.w) * 100}%`, height: `${(alt / dim.h) * 100}%` };
  };
  const sposta = (e) => {
    const r = area.current.getBoundingClientRect();
    const x = Math.round(Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100)));
    const y = Math.round(Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100)));
    onPos({ x, y });
  };
  const zPc = zona(1280, hPc), zTel = zona(390, hTel);
  const piccola = dim && dim.w < 1200;

  return (
    <div style={{ marginTop: 14 }}>
      <label style={s.label}><Move size={11} style={{ verticalAlign: '-1px' }} /> INQUADRATURA · trascina il punto su ciò che deve restare in vista</label>
      <div ref={area}
        style={{ position: 'relative', borderRadius: 10, overflow: 'hidden', cursor: disabled ? 'default' : 'crosshair', touchAction: 'none', userSelect: 'none', background: '#000' }}
        onPointerDown={e => { if (disabled) return; trascina.current = true; e.currentTarget.setPointerCapture(e.pointerId); sposta(e); }}
        onPointerMove={e => { if (trascina.current) sposta(e); }}
        onPointerUp={() => { trascina.current = false; }}>
        <img src={src} alt="" draggable={false} onLoad={e => setDim({ w: e.target.naturalWidth, h: e.target.naturalHeight })} style={{ display: 'block', width: '100%' }} />
        {zPc && <div style={{ ...st.zona, ...zPc, borderColor: '#fff', boxShadow: '0 0 0 9999px rgba(0,0,0,.5)' }}><span style={st.zonaLbl}>Computer</span></div>}
        {zTel && <div style={{ ...st.zona, ...zTel, borderColor: '#F4600C', borderStyle: 'dashed' }}><span style={{ ...st.zonaLbl, background: '#F4600C', top: 'auto', bottom: 4 }}>Telefono</span></div>}
        <div style={{ position: 'absolute', left: `${pos.x}%`, top: `${pos.y}%`, width: 22, height: 22, marginLeft: -11, marginTop: -11, borderRadius: '50%', border: '3px solid #fff', background: '#F4600C', boxShadow: '0 2px 8px rgba(0,0,0,.5)', pointerEvents: 'none' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap', marginTop: 6 }}>
        <span style={s.help}>{dim ? `Foto ${dim.w} × ${dim.h} px` : ''}</span>
        <button type="button" style={{ ...s.btnSec, padding: '4px 10px' }} onClick={() => onPos({ x: 50, y: 50 })} disabled={disabled}>CENTRA</button>
      </div>
      {piccola && <p style={{ ...s.help, color: '#B45309' }}>La foto è piccola: su schermi grandi potrebbe sembrare sgranata. Meglio una da almeno 1600 px di larghezza.</p>}
    </div>
  );
}

function Chip({ on, onClick, children, campione }) {
  return (
    <button type="button" onClick={onClick} style={{ ...st.chip, ...(on ? st.chipOn : {}) }}>
      {campione && <i style={{ width: 14, height: 14, borderRadius: 4, background: campione, display: 'inline-block', boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.12)' }} />}
      {children}
    </button>
  );
}

const st = {
  griglia: { display: 'grid', gridTemplateColumns: 'minmax(300px, 400px) minmax(0, 1fr)', gap: 18, alignItems: 'start' },
  colonnaAnteprima: { position: 'sticky', top: 12, minWidth: 0 },
  temi: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 },
  tema: { border: '1px solid var(--border2)', borderRadius: 12, padding: 0, overflow: 'hidden', background: '#F5F5F7', textAlign: 'left', color: 'var(--text)', cursor: 'pointer' },
  temaOn: { borderColor: '#F4600C', boxShadow: '0 0 0 2px #F4600C' },
  temaImg: { display: 'block', height: 46 },
  temaNome: { display: 'block', padding: '6px 9px', fontSize: 12.5, fontWeight: 600 },
  radio: { display: 'flex', gap: 10, alignItems: 'flex-start', border: '1px solid var(--border2)', borderRadius: 12, padding: '9px 11px', cursor: 'pointer', fontSize: 'var(--font-size-sm)' },
  radioOn: { borderColor: '#F4600C', background: 'rgba(244,96,12,.06)' },
  chips: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  chip: { display: 'inline-flex', alignItems: 'center', gap: 6, border: '1px solid var(--border2)', background: '#F5F5F7', color: 'var(--text)', borderRadius: 999, padding: '7px 11px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  chipOn: { borderColor: '#F4600C', boxShadow: 'inset 0 0 0 1px #F4600C', background: 'rgba(244,96,12,.06)' },
  check: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 'var(--font-size-sm)', cursor: 'pointer', marginTop: 12 },
  consiglio: { marginTop: 12, background: 'var(--bg-input)', borderRadius: 10, padding: '10px 12px', fontSize: 'var(--font-size-xs)', lineHeight: 1.55, color: 'var(--text-dim)' },
  etichetta: { display: 'inline-flex', alignItems: 'center', gap: 4, background: 'var(--bg-input)', border: '1px solid var(--border2)', borderRadius: 999, padding: '4px 6px 4px 11px', fontSize: 12.5, fontWeight: 600 },
  xBtn: { background: 'transparent', border: 0, color: 'var(--text-dim)', cursor: 'pointer', display: 'flex', padding: 2 },
  seg: { display: 'inline-flex', background: 'var(--bg-input)', borderRadius: 999, padding: 3, gap: 2 },
  segBtn: { display: 'inline-flex', alignItems: 'center', gap: 5, border: 0, background: 'transparent', color: 'var(--text-dim)', fontSize: 12.5, fontWeight: 600, padding: '6px 12px', borderRadius: 999, cursor: 'pointer' },
  segOn: { background: '#C24B08', color: '#fff' },
  zona: { position: 'absolute', border: '2px solid', borderRadius: 4, pointerEvents: 'none' },
  zonaLbl: { position: 'absolute', top: 4, left: 4, background: 'rgba(0,0,0,.6)', color: '#fff', fontSize: 10.5, fontWeight: 700, padding: '2px 6px', borderRadius: 4, letterSpacing: .3 },
};
